import ModelFactory from '../model-factory';
import { User } from '../user';
import Activity from './activity';
import {
  BaseModel,
  AffectedResource,
  Category,
  ClaimType,
  Location,
  Priority,
  Status,
  TicketProperty,
  Type,
  Group,
  Attachment,
  SurveyAnswer,
} from '../models';

export default class Ticket extends BaseModel {
  constructor(data = {}) {
    super(data);
    // Formatear respuestas del detalle de un ticket
    this.id = data.id || data['@id'] || null;

    if (this.id == null && this.relAttr != null) {
      try {
        this.id = this.relAttr.substr(3);
      } catch (ex) {
        // ignored exception
      }
    }
    this.description = data.description || null;
    this.lastModificationDate = data.last_mod_dt || null;
    this.openDate = data.open_date || null;
    this.closeDate = data.close_date || null;
    this.resolveDate = data.resolve_date || null;
    this.referenceNumber = data.ref_num || null;
    this.summary = data.summary || null;
    this.entorno = data.zentorno || null;
    this.approbalWorkflowOrder = data.string5 || null;
    this.group = data.group || null;
    this.externalSystemTicket = data.external_system_ticket;
    this.call_back_date = data.call_back_date || null;
    this.zmot_parada = data.zmot_parada || null;
    this.in_flag = data.in_flag || null;
    this.cr_flag = data.cr_flag || null;
    this.isSuscriptor = data.is_suscriptor || data.zsuscriptor || null;
    this.isSeguidor = data.is_seguidor || null;
    this.affectedResource = null;
    this.tooltip = data.zmics_alt_cat || null;

    if (data.affected_resource != null) {
      this.affectedResource = new AffectedResource(data.affected_resource);
    }
    this.assignee = null;
    if (data.assignee != null) {
      this.assignee = new User(data.assignee);
    }

    this.parent = null;
    // puede venir el padre del reclamada como origin
    if (data.parent != null) {
      this.parent = new Ticket(data.parent);
    } else if (data.origin != null) {
      // unique() no funciona. Se implementa [0] para el desarrollo
      this.parent = new Ticket(data.origin[0]);
    }

    this.category = null;
    if (data.category != null) {
      this.category = new Category(data.category);
      // list/search responses use a non-prefixed shape (ID/SYM/PERSID)
      // instead of the detail endpoint's (@id/@COMMON_NAME/@REL_ATTR)
      this.category.id = this.category.id || data.category.ID || null;
      this.category.name = this.category.name || data.category.SYM || null;
    }

    this.customer = null;
    if (data.customer != null) {
      this.customer = new User(data.customer);
    }

    this.location = null;
    if (data.zlocation != null) {
      this.location = new Location(data.zlocation);
    } else if (data.location != null) {
      this.location = new Location(data.location);
    }

    this.priority = null;
    if (data.priority != null) {
      this.priority = new Priority(data.priority);
    }

    this.requestedBy = null;
    if (data.requested_by != null) {
      this.requestedBy = new User(data.requested_by);
    }

    this.status = null;
    if (data.status != null) {
      this.status = new Status(data.status);
    }

    this.type = null;
    if (data.type != null) {
      this.type = new Type(data.type);
    }

    this.group = null;
    if (data.group != null) {
      this.group = new Group(data.group);
    }

    this.claimType = null;
    if (data.claim_type != null) {
      this.claimType = new ClaimType(data.claim_type);
    }

    this.properties = [];
    if (data.properties != null && data.properties.length > 0) {
      this.properties = data.properties.map((propertyData) => new TicketProperty(propertyData));
    }

    this.related = [];
    if (data.related != null) {
      // unique() no funciona. Se implementa [0] para el desarrollo
      this.related = data.related.map((relatedData) => new Ticket(relatedData));
    }

    this.zreclamaciones = [];
    if (data.zreclamaciones != null) {
      // unique() no funciona. Se implementa [0] para el desarrollo
      this.zreclamaciones = data.zreclamaciones;
    }

    this.activities = [];
    if (data.activities != null && data.activities.length > 0) {
      this.activities = data.activities.map((activity) => new Activity(activity));
    }

    this.isImpact = null;
    if (data.isImpact != null) {
      this.isImpact = data.isImpact;
    }

    this.surveyanswer = null;
    if (data.surveyanswer != null) {
      this.surveyanswer = new SurveyAnswer(data.surveyanswer);
    }

    this.attachments = [];
    if (data.attachments != null && data.attachments.length > 0) {
      this.attachments = data.attachments.map((attach) => new Attachment(attach));
    }

    this.zcatalogci = null;
    if (data.zcatalog_ci && data.zcatalog_ci['@id'] != null) {
      this.zcatalogci = data.zcatalog_ci['@id'];
    }

    this.errors = [];
    this.success = [];
    if (data.resultArray != null && data.resultArray.length > 0) {
      this.success = data.resultArray.filter((error) => error.status === 200);
      this.errors = data.resultArray.filter((error) => error.status === 500);
    }

    this.$attachments = [];
    if (data.$attachments != null && data.$attachments.length > 0) {
      this.$attachments = [].concat(data.$attachments);
    }

    this.phoneTicket = null;
    if (data.ztelefono_contacto != null) {
      this.phoneTicket = data.ztelefono_contacto;
    }

    this.icon = null;
    if (data.resource_alias != null) {
      this.icon = data.resource_alias;
    }
  }

  hasPortafirmasRequest() {
    return typeof this.externalSystemTicket === 'string'
      && this.externalSystemTicket.startsWith('portafirmas:');
  }

  getPortafirmasRequestId() {
    return this.hasPortafirmasRequest() ? this.externalSystemTicket.replace('portafirmas:', '') : null;
  }
}

export const formatTicketType = (type) => {
  let ticketService = 'ticket/request';
  if (type === 'I') {
    ticketService = 'ticket/incident';
  } else if (type === 'P') {
    ticketService = 'ticket/problem';
  }
  return ticketService;
};

export const modelFactory = new ModelFactory('ticket', (res) => new Ticket(res));
/* export const formatTicket = (data) => {
  return modelFactory.format(data);
}; */
